import { Component, OnInit, Optional } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { firstValueFrom, Subscription } from 'rxjs';
import { CustomListDropdown } from 'src/app/interfaces/custom-list/custom-list-dropdown.interface';
import { ModalObjectType } from 'src/app/interfaces/modal-object-types.interface';
import { ToastHandlerService } from 'src/app/services/toast/toast-handler.service';
import { InvoiceModel } from './../../../../models/invoicing/invoice.model';
import { InvoiceService } from './../../../../services/invoicing/invoice.service';

@Component({
  selector: 'app-copy-invoice',
  templateUrl: './copy-invoice.component.html',
  styleUrls: ['./copy-invoice.component.scss'],
  standalone: false
})
export class CopyInvoiceComponent implements OnInit {

  invoiceModel: InvoiceModel = new InvoiceModel();
  listBussinessDocumentsTypes: CustomListDropdown[] = [];

  bussinessDocumentsTypeId: number = 0;
  consecutive: number = 0;
  suscription: Subscription;

  constructor(private invoiceService: InvoiceService,
    public config: DynamicDialogConfig,
    private toastHandlerService: ToastHandlerService,
    @Optional() private ref: DynamicDialogRef) { }


  async ngOnInit(): Promise<void> {
    const input$ = this.config.data?.inputs$;
    if (!input$) {
      console.error('inputs$ no está definido en config.data');
      return;
    }

    this.suscription = input$?.subscribe((inputs: any) => {
      this.invoiceModel = inputs.invoiceModel;
      this.listBussinessDocumentsTypes = inputs.listBussinessDocumentsTypes;
    });
  }

  ngOnDestroy() {
    this.suscription?.unsubscribe();
  }

  async copyInvoice() {
    if (this.bussinessDocumentsTypeId == 0 || this.bussinessDocumentsTypeId == null) {
      this.toastHandlerService.showToast('warning', `Debe seleccionar un tipo de Doc. Comercial válido.`, 'Atención.');
      return;
    }
    if (this.consecutive == 0 || this.consecutive == null) {
      this.toastHandlerService.showToast('warning', `Debe ingresar un número de Factura válido.`, 'Atención.');
      return;
    }

    try {
      const response = await firstValueFrom(this.invoiceService.copyInvoice(this.invoiceModel.invoiceId, this.bussinessDocumentsTypeId, this.consecutive));
      this.toastHandlerService.showToast('success', `La Factura fue copiada exitosamente.`);

      const data: ModalObjectType = {};
      data.params = { updateInvoice: response };
      this.ref.close(data);
    } catch (error) {
      console.error('Error al copiar la factura.', error);
      this.toastHandlerService.showToast('error', `Error al copiar la factura.`, 'Error');
    }
  }

  getBussinessDocumentsType(bussinessDocumentsTypeId: number | null) {
    if (bussinessDocumentsTypeId != null && bussinessDocumentsTypeId != 0) {
      this.bussinessDocumentsTypeId = bussinessDocumentsTypeId;
    } else {
      this.bussinessDocumentsTypeId = 0;
    }
  }
}
